import md5 from 'md5';
import moment from 'moment';
import BaseModel from '@/models/Base';
import Source from '@/models/content/Source';
import Enclosure from '@/models/content/Enclosure';
import Topic from '@/models/strategy/Topic';

export default class Item extends BaseModel {
  static entity = 'items';

  static autoNormalize = [
    {
      model: Source,
      key: 'source',
      type: 'single'
    },
    {
      model: Topic,
      key: 'topics',
      type: 'collection'
    }
  ];

  static deepGet = [
    { parent: 'enclosure', child: 'url' },
    { parent: 'enclosure', child: 'type' }
  ];

  static fields() {
    return {
      ...super.fields(),
      url: this.string(''),
      title: this.string(''),
      content: this.string(''),
      likeCount: this.number(0),
      commentCount: this.number(0),
      likeUrl: this.string(''),
      unlikeUrl: this.string(''),
      pinUrl: this.string(''),
      unpinUrl: this.string(''),
      commentsUrl: this.string(''),
      source_id: this.string(''),
      source: this.belongsTo(Source, 'source_id'),
      enclosure_url: this.string(''),
      enclosure_type: this.string(''),
      reason: this.string(''),
      topics_collection: this.attr([])
    };
  }

  get topics() {
    const topics = [];

    if (this.topics_collection.length > 0) {
      this.topics_collection.forEach(topicId => {
        let result = Topic.query()
          .where(topic => {
            return topic.id === topicId;
          })
          .first();
        topics.push(result);
      });
    }

    return topics;
  }

  get maxWords() {
    return 25;
  }

  get intro() {
    return this.content
      .split(' ')
      .slice(0, this.maxWords)
      .join(' ');
  }

  get showIntro() {
    return this.content.split(' ').length > this.maxWords;
  }

  get formattedContent() {
    let protocol = '(?:(?:[a-z]+:)?//)';
    let auth = '(?:\\S+(?::\\S*)?@)?';
    let host = '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)';
    let domain =
      '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*';
    let tld = '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?';
    let port = '(?::\\d{2,5})?';
    let path = "(?:[/?#][^\\s']*)?";
    let regex = `(?:${protocol}|www\\.)${auth}(?:localhost|${host}${domain}${tld})${port}${path}`;
    let pattern = new RegExp(regex, 'ig');

    return this.content.replace(pattern, function(url) {
      return `<a href="${url}" target="_blank" class="external">${url}</a>`;
    });
  }

  get isImage() {
    return this.enclosure_type.indexOf('image') > -1;
  }

  get isVideo() {
    return this.enclosure_type.indexOf('video') > -1;
  }

  get canLike() {
    return this.likeUrl.length > 0;
  }

  get canUnlike() {
    return this.unlikeUrl.length > 0;
  }

  get isLiked() {
    if (this.canUnlike == false && this.canLike == false) {
      return false;
    }

    return this.canUnlike != false;
  }

  get canPin() {
    return this.pinUrl.length > 0;
  }

  get canUnpin() {
    return this.unpinUrl.length > 0;
  }

  get isPinned() {
    if (this.canUnpin == false && this.canPin == false) {
      return false;
    }

    return this.canUnpin != false;
  }

  get createdAtString() {
    return moment(this.createdAt).format('DD-MM-YYYY H:mm');
  }

  get createdAtSorter() {
    return this.createdAt ? moment(this.createdAt).format('x') : 0;
  }

  get hash() {
    return md5(`${this.source_id}${this.content}${this.createdAtString}`);
  }
}
